// extracted by mini-css-extract-plugin
export default {"opacity":"styles_opacity__Islee","opacityAnimation":"styles_opacityAnimation__k1YC1"};